/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';

export const HeroHome = () => (
  <div id="tf-home" className="text-center">
    <div className="overlay">
      <div className="content">
        <h1><strong><span className="color"> ΠΟωaττ</span></strong></h1>
        <p className="lead">Delivering efficient, targeted, <strong>Predictive Maintenance</strong></p>
        <p className="lead">
          <a className="page-scroll" href="#tf-works"><i className="fa fa-angle-down" /></a>
          <strong> Get it fixed before it fails...</strong>
        </p>
      </div>
    </div>
  </div>
);

export const HeroMm = () => (
  <div id="tf-mmhome" className="text-center">
    <div className="overlay">
      <div className="content">
        <h1><strong><span className="color"> ΠΟωaττ</span></strong></h1>
        <p className="lead">Predictive Maintenance - <strong>preventing</strong> problems <strong>before</strong> they happen</p>
        <a className="page-scroll" href="#tf-mmabout"><i className="fa fa-angle-down" /></a>
        <p className="lead"><strong> Insight from afar...</strong></p>
      </div>
    </div>
  </div>
);

export const HeroAnalysis = () => (
  <div id="tf-analhome" className="text-center">
    <div className="overlay">
      <div className="content">
        <h1><strong><span className="color"> ΠΟωaττ</span></strong></h1>
        <p className="lead">Applying <strong>artificial intelligence</strong> to big data at <strong>scale</strong></p>
        <a className="page-scroll" href="#tf-analabout"><i className="fa fa-angle-down" /></a>
        <p className="lead"><strong> See what our AI engine sees...</strong></p>
      </div>
    </div>
  </div>
);

export const HeroInside = () => (
  <div id="tf-inhome" className="text-center">
    <div className="overlay">
      <div className="content">
        <h1><strong><span className="color"> ΠΟωaττ</span></strong></h1>
        <p className="lead">Built-in <strong>inside</strong> your new appliances</p>
        <a className="page-scroll" href="#tf-inabout"><i className="fa fa-angle-down" /></a>
        <p className="lead"><strong> Plugin and start saving...</strong></p>
      </div>
    </div>
  </div>
);

export const HeroSmp = () => (
  <div id="tf-smphome" className="text-center">
    <div className="overlay">
      <div className="content">
        <h1><strong><span className="color"> ΠΟωaττ</span></strong></h1>
        <p className="lead">Smart Monitoring <strong>PLUS+</strong> taking care of <strong>legacy</strong> appliances and infrastructure</p>
        <a className="page-scroll" href="#tf-smpabout"><i className="fa fa-angle-down" /></a>
        <p className="lead"><strong> Upgrade what you already have...</strong></p>
      </div>
    </div>
  </div>
);
